import React from 'react';
import EditApkState from './editApkState/EditApkState';
import Form from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';

const EditApkPage: React.FC = () => {
	return (
		<EditApkState>
			<Form />
			<ModalWindows />
		</EditApkState>
	);
};

export default EditApkPage;
